import React from 'react';
import PrintOrderCommon from './PrintOrderCommon';

const OrderPrint = () => {
  return (
    <div>
      <PrintOrderCommon />
    </div>
  );
};

export default OrderPrint; 